import types from "./types";

export function allAdmins() {
  return { type: types.ALL_ADMINS_RESERVA_CARRROS };
}
export function allAdminsVANS() {
  return { type: types.ALL_ADMINS_VANS };
}
export function updateAdmin(payload) {
    return { type: types.UPDATE_ADMIN , payload};
  }
  
  export function filterAdmins() {
    return { type: types.FILTER_ADMINS };
  }
  export function addAdmins() {
    return { type: types.ADD_ADMINS };
  }
  export function addAdminsStepTwo() {
    return { type: types.ADD_ADMINS_TWO };
  }
  export function resetAdmins() {
    return { type: types.RESET_ADMINS };
  }
  export function unlinkAdmins() { //Soft Remove
    return { type: types.UNLINK_ADMINS };
  }
  export function checkOutCar() { //Soft Remove
    return { type: types.CHECK_OUT };
  }
  export function loginSessionAdmin(payload) {
    return { type: types.LOGIN_ADMIN_SESSION_IN , payload};
  }
  
  export function sessionLogOut() { //Soft Remove
    return { type: types.LOGIN_SESSION_OUT  };
  }